<template>
  <common-assets-template>
    <template v-slot:body>
      <!-- leargeサイズ -->
      <h2>leargeサイズ</h2>
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :bg_red="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :border_red="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :no_width="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :font_bold="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :border_red_text_black="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :icon="'icon-favourite'" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample" />

      <!-- middleサイズ -->
      <h2>middleサイズ</h2>
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :bg_red="true"
        :middle="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true"
        :border_red="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true"
        :no_width="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true"
        :font_bold="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true"
        :border_red_text_black="true"  />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true"
        :icon="'icon-favourite'" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :middle="true" />


      <!-- smallサイズ -->
      <h2>smallサイズ</h2>
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :bg_red="true"
        :small="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true"
        :border_red="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true"
        :no_width="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true"
        :font_bold="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true"
        :border_red_text_black="true" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true"
        :icon="'icon-favourite'" />
      <common-button
        class="u-m10"
        :callback="sampleFunction"
        :title="sample"
        :small="true" />

      <!-- selectボタン -->
      <h2>selectボタン</h2>
      <common-select
        class="u-m10" />
      <common-select
        class="u-m10"
        :learge="true" />
      <common-select
        class="u-m10"
        :middle="true" />
      <common-select
        class="u-m10"
        :round="true" />
      <common-select
        class="u-m10"
        :up_down_icon="true" />
      <common-select
        class="u-m10"
        :learge="true"
        :round="true"
        :up_down_icon="true" />


      <h2>ローディング</h2>
      <search-loading />
    </template>
  </common-assets-template>
</template>

<script>
import CommonButton from '@/components/parts/button/CommonButton';
import CommonSelect from '@/components/parts/select/CommonSelect';
import SearchLoading from '@/components/search/kodate/SearchLoading';
import CommonAssetsTemplate from '@/components/templates/CommonAssetsTemplate';

export default {
  name: 'AssetsList',
  components: {
    CommonButton,
    CommonSelect,
    CommonAssetsTemplate,
    SearchLoading,
  },
  data() {
    return {
      sample: 'サンプル',
    };
  },
  methods: {
    sampleFunction() {
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss">
@charset "UTF-8";
  .u-m10 {
    margin-top:10px;
    margin-bottom:10px;
  }
</style>
